import style from "./personalData.module.css";

const URL = "primpivo25.ru";

const personalData = () => {
  return (
    <section className={style.wrapper}>
      <h2 className={style.title}>
        Политика в отношении обработки персональных данных
      </h2>
      <div>
        <h5 className={style.title_ph}>1. Общие положения</h5>
        <h5 className={style.title_ph}>
          Настоящая политика обработки персональных данных составлена в
          соответствии с требованиями Федерального закона от 27.07.2006. №
          152-ФЗ «О персональных данных» (далее — Закон о персональных данных) и
          определяет порядок обработки персональных данных и меры по обеспечению
          безопасности персональных данных, предпринимаемые ООО "Примпиво".
          Юридический адрес: 690074, Приморский край, г Владивосток, Снеговая
          ул, д. 34, этаж 1 помещ. 2. ОГРН 1222500011601. ИНН 2543165707. (далее
          — Оператор).
        </h5>
        <p className={style.ph}>
          1.1. Оператор ставит своей важнейшей целью и условием осуществления
          своей деятельности соблюдение прав и свобод человека и гражданина при
          обработке его персональных данных, в том числе защиты прав на
          неприкосновенность частной жизни, личную и семейную тайну.
        </p>
        <p className={style.ph}>
          1.2. Настоящая политика Оператора в отношении обработки персональных
          данных (далее — Политика) применяется ко всей информации, которую
          Оператор может получить о посетителях веб-сайта {URL}.
        </p>
      </div>
      <div>
        <h5 className={style.title_ph}>
          2. Основные понятия, используемые в Политике
        </h5>
        <p className={style.ph}>
          2.1. Автоматизированная обработка персональных данных — обработка
          персональных данных с помощью средств вычислительной техники.
        </p>
        <p className={style.ph}>
          2.2. Блокирование персональных данных — временное прекращение
          обработки персональных данных (за исключением случаев, если обработка
          необходима для уточнения персональных данных).
        </p>
        <p className={style.ph}>
          2.3. Веб-сайт — совокупность графических и информационных материалов,
          а также программ для ЭВМ и баз данных, обеспечивающих их доступность в
          сети интернет по сетевому адресу {URL}.
        </p>
        <p className={style.ph}>
          2.4. Информационная система персональных данных — совокупность
          содержащихся в базах данных персональных данных и обеспечивающих их
          обработку информационных технологий и технических средств.
        </p>
        <p className={style.ph}>
          2.5. Обезличивание персональных данных — действия, в результате
          которых невозможно определить без использования дополнительной
          информации принадлежность персональных данных конкретному Пользователю
          или иному субъекту персональных данных.
        </p>
        <p className={style.ph}>
          2.6. Обработка персональных данных — любое действие (операция) или
          совокупность действий (операций), совершаемых с использованием средств
          автоматизации или без использования таких средств с персональными
          данными, включая сбор, запись, систематизацию, накопление, хранение,
          уточнение (обновление, изменение), извлечение, использование, передачу
          (распространение, предоставление, доступ), обезличивание,
          блокирование, удаление, уничтожение персональных данных.
        </p>
        <p className={style.ph}>
          2.7. Оператор — государственный орган, муниципальный орган,
          юридическое или физическое лицо, самостоятельно или совместно с
          другими лицами организующие и/или осуществляющие обработку
          персональных данных, а также определяющие цели обработки персональных
          данных, состав персональных данных, подлежащих обработке, действия
          (операции), совершаемые с персональными данными.
        </p>
        <p className={style.ph}>
          2.8. Персональные данные — любая информация, относящаяся прямо или
          косвенно к определенному или определяемому Пользователю веб-сайта
          {URL}.
        </p>
        <p className={style.ph}>
          2.9 Персональные данные, разрешенные субъектом персональных данных для
          распространения, — персональные данные, доступ неограниченного круга
          лиц к которым предоставлен субъектом персональных данных путем дачи
          согласия на обработку персональных данных, разрешенных субъектом
          персональных данных для распространения в порядке, предусмотренном
          Законом о персональных данных (далее — персональные данные,
          разрешенные для распространения).
        </p>
        <p className={style.ph}>
          2.10. Пользователь — любой посетитель веб-сайта {URL}.
        </p>
        <p className={style.ph}>
          2.11. Предоставление персональных данных — действия, направленные на
          раскрытие персональных данных определенному лицу или определенному
          кругу лиц.
        </p>
        <p className={style.ph}>
          2.12. Распространение персональных данных — любые действия,
          направленные на раскрытие персональных данных неопределенному кругу
          лиц (передача персональных данных) или на ознакомление с персональными
          данными неограниченного круга лиц, в том числе обнародование
          персональных данных в средствах массовой информации, размещение в
          информационно-телекоммуникационных сетях или предоставление доступа к
          персональным данным каким-либо иным способом.
        </p>
        <p className={style.ph}>
          2.13. Трансграничная передача персональных данных — передача
          персональных данных на территорию иностранного государства органу
          власти иностранного государства, иностранному физическому или
          иностранному юридическому лицу.
        </p>
        <p className={style.ph}>
          2.14. Уничтожение персональных данных — любые действия, в результате
          которых персональные данные уничтожаются безвозвратно с невозможностью
          дальнейшего восстановления содержания персональных данных в
          информационной системе персональных данных и/или уничтожаются
          материальные носители персональных данных.
        </p>
      </div>
      <div>
        <h5 className={style.title_ph}>
          3. Цели обработки персональных данных
        </h5>
        <p className={style.ph}>
          3.1 Цель обработки - предоставление доступа Пользователю к сервисам,
          информации и/или материалам, содержащимся на веб-сайте
        </p>
        <p className={style.ph}>
          3.2 Персональные данные - сбор и обработка обезличенных данных о
          посетителях (в т.ч. файлов «cookie») с помощью сервисов
          интернет-статистики (Яндекс Метрика и Гугл Аналитика и других).
        </p>
        <p className={style.ph}>
          3.3 Правовые основания - Федеральный закон «Об информации,
          информационных технологиях и о защите информации» от 27.07.2006 N
          149-ФЗ
        </p>
        <p className={style.ph}>
          3.4 Виды обработки персональных данных - Сбор, запись, систематизация,
          накопление, хранение, уничтожение и обезличивание персональных данных
        </p>
      </div>
      <div>
        <h5 className={style.title_ph}>
          4. Условия обработки персональных данных
        </h5>
        <p className={style.ph}>
          4.1. Обработка персональных данных осуществляется с согласия субъекта
          персональных данных на обработку его персональных данных.
        </p>
        <p className={style.ph}>
          4.2. Обработка персональных данных необходима для достижения целей,
          предусмотренных международным договором Российской Федерации или
          законом, для осуществления возложенных законодательством Российской
          Федерации на оператора функций, полномочий и обязанностей.
        </p>
        <p className={style.ph}>
          4.3. Обработка персональных данных необходима для осуществления
          правосудия, исполнения судебного акта, акта другого органа или
          должностного лица, подлежащих исполнению в соответствии с
          законодательством Российской Федерации об исполнительном производстве.
        </p>
        <p className={style.ph}>
          4.4. Обработка персональных данных необходима для исполнения договора,
          стороной которого либо выгодоприобретателем или поручителем по
          которому является субъект персональных данных, а также для заключения
          договора по инициативе субъекта персональных данных или договора, по
          которому субъект персональных данных будет являться
          выгодоприобретателем или поручителем.
        </p>
        <p className={style.ph}>
          4.5. Обработка персональных данных необходима для осуществления прав и
          законных интересов оператора или третьих лиц либо для достижения
          общественно значимых целей при условии, что при этом не нарушаются
          права и свободы субъекта персональных данных.
        </p>
        <p className={style.ph}>
          4.6. Осуществляется обработка персональных данных, доступ
          неограниченного круга лиц к которым предоставлен субъектом
          персональных данных либо по его просьбе (далее — общедоступные
          персональные данные).
        </p>
        <p className={style.ph}>
          4.7. Осуществляется обработка персональных данных, подлежащих
          опубликованию или обязательному раскрытию в соответствии с федеральным
          законом.
        </p>
      </div>
      <div>
        <h5 className={style.title_ph}>
          5. Порядок сбора, хранения, передачи и других видов обработки
          персональных данных
        </h5>
        <h5 className={style.title_ph}>
          Безопасность персональных данных, которые обрабатываются Оператором,
          обеспечивается путем реализации правовых, организационных и
          технических мер, необходимых для выполнения в полном объеме требований
          действующего законодательства в области защиты персональных данных.
        </h5>
        <p className={style.ph}>
          5.1. Оператор обеспечивает сохранность персональных данных и принимает
          все возможные меры, исключающие доступ к персональным данным
          неуполномоченных лиц.
        </p>
        <p className={style.ph}>
          5.2. Персональные данные Пользователя никогда, ни при каких условиях
          не будут переданы третьим лицам, за исключением случаев, связанных с
          исполнением действующего законодательства либо в случае, если
          субъектом персональных данных дано согласие Оператору на передачу
          данных третьему лицу для исполнения обязательств по
          гражданско-правовому договору.
        </p>
        <p className={style.ph}>
          5.3. В случае выявления неточностей в персональных данных,
          Пользователь может актуализировать их самостоятельно, путем
          направления Оператору уведомление на адрес электронной почты Оператора
          office@primpivo.ru с пометкой «Актуализация персональных данных».
        </p>
        <p className={style.ph}>
          5.4. Срок обработки персональных данных определяется достижением
          целей, для которых были собраны персональные данные, если иной срок не
          предусмотрен договором или действующим законодательством. Пользователь
          может в любой момент отозвать свое согласие на обработку персональных
          данных, направив Оператору уведомление посредством электронной почты
          на электронный адрес Оператора office@primpivo.ru с пометкой «Отзыв
          согласия на обработку персональных данных».
        </p>
        <p className={style.ph}>
          5.5. Вся информация, которая собирается сторонними сервисами, в том
          числе платежными системами, средствами связи и другими поставщиками
          услуг, хранится и обрабатывается указанными лицами (Операторами) в
          соответствии с их Пользовательским соглашением и Политикой
          конфиденциальности. Субъект персональных данных и/или с указанными
          документами. Оператор не несет ответственность за действия третьих
          лиц, в том числе указанных в настоящем пункте поставщиков услуг.
        </p>
        <p className={style.ph}>
          5.6. Установленные субъектом персональных данных запреты на передачу
          (кроме предоставления доступа), а также на обработку или условия
          обработки (кроме получения доступа) персональных данных, разрешенных
          для распространения, не действуют в случаях обработки персональных
          данных в государственных, общественных и иных публичных интересах,
          определенных законодательством РФ.
        </p>
        <p className={style.ph}>
          5.7. Оператор при обработке персональных данных обеспечивает
          конфиденциальность персональных данных.
        </p>
        <p className={style.ph}>
          5.8. Оператор осуществляет хранение персональных данных в форме,
          позволяющей определить субъекта персональных данных, не дольше, чем
          этого требуют цели обработки персональных данных, если срок хранения
          персональных данных не установлен федеральным законом, договором,
          стороной которого, выгодоприобретателем или поручителем по которому
          является субъект персональных данных.
        </p>
        <p className={style.ph}>
          5.9. Условием прекращения обработки персональных данных может являться
          достижение целей обработки персональных данных, истечение срока
          действия согласия субъекта персональных данных, отзыв согласия
          субъектом персональных данных или требование о прекращении обработки
          персональных данных, а также выявление неправомерной обработки
          персональных данных.
        </p>
      </div>
      <div>
        <h5 className={style.title_ph}>
          6. Трансграничная передача персональных данных
        </h5>
        <p className={style.ph}>
          6.1. Оператор до начала осуществления деятельности по трансграничной
          передаче персональных данных обязан уведомить уполномоченный орган по
          защите прав субъектов персональных данных о своем намерении
          осуществлять трансграничную передачу персональных данных (такое
          уведомление направляется отдельно от уведомления о намерении
          осуществлять обработку персональных данных).
        </p>
        <p className={style.ph}>
          6.2. Оператор до подачи вышеуказанного уведомления, обязан получить от
          органов власти иностранного государства, иностранных физических лиц,
          иностранных юридических лиц, которым планируется трансграничная
          передача персональных данных, соответствующие сведения.
        </p>
      </div>
      <div>
        <h5 className={style.title_ph}>
          7. Конфиденциальность персональных данных
        </h5>
        <p className={style.ph}>
          Оператор и иные лица, получившие доступ к персональным данным, обязаны
          не раскрывать третьим лицам и не распространять персональные данные
          без согласия субъекта персональных данных, если иное не предусмотрено
          федеральным законом.
        </p>
      </div>
      <div>
        <h5 className={style.title_ph}>8. Заключительные положения</h5>
        <p className={style.ph}>
          8.1. Пользователь может получить любые разъяснения по интересующим
          вопросам, касающимся обработки его персональных данных, обратившись к
          Оператору с помощью электронной почты office@primpivo.ru.
        </p>
        <p className={style.ph}>
          8.2. В данном документе будут отражены любые изменения политики
          обработки персональных данных Оператором. Политика действует бессрочно
          до замены ее новой версией.
        </p>
        <p className={style.ph}>
          8.3. Актуальная версия Политики в свободном доступе расположена в сети
          Интернет по адресу {URL}.
        </p>
      </div>
      <div className={style.oferta}>Информация на сайте не является публичной офертой</div>
    </section>
  );
};

export default personalData;
